const os = require("os");
export const INVALID_1000 = -1000;
export const MAP_K_DATA = 337.5;
export const INVALID_1 = -1;
export const EOL = os.EOL;
export const IMAGESIZE = {
  width: 2048,
  height: 1536
};
export const PAGES = {
  questionnaire: "questionnaire",
  capture: "capture",
  dryeye: "dryeye",
  topography: "topography",
  settings: "settings",
  patientmanager: "patient-manager",
  pupilcorneadia: "pupilcorneadia"
};
export const CHECKTYPES = {
  dryeye: "dryeye",
  topography: "topography"
};
export const SPECIALKEYS =
  " [ ` ~ ! ￥ # $ % ^ & * ( ) _ + < > ? —— : = \" { } , .  / ; ：；【 】… ' [ ] ";
export const DRYEYEMODES = {
  questionnaire: { key: "questionnaire", label: "txtQNaire", cam: "photo" },
  tearheight: { key: "tearheight", label: "txtTearHeight", cam: "photo" },
  nibut: { key: "nibut", label: "txtNibut", cam: "video" },
  lipidlayer: { key: "lipidlayer", label: "txtLipidLayer", cam: "video" },
  meibomian: { key: "meibomian", label: "txtMeibomian", cam: "photo" },
  eyelidedge: { key: "eyelidedge", label: "txtEyelidEdge", cam: "photo" },
  eyeredness: { key: "eyeredness", label: "txtEyeRedness", cam: "photo" },
  blink: { key: "blink", label: "txtBlink", cam: "video" },
  fbut: { key: "fbut", label: "txtBut", cam: "video" },
  ocularsurface: {
    key: "ocularsurface",
    label: "txtOcularSurface",
    cam: "photo"
  }
};
export const TOPOGRAPHYMODES = {
  largemap: {
    key: "largemap",
    label: "txtLargeMap",
    rightsider: {
      visible: true, // 是否显示右边栏
      isMapBoolen: false, // 右边栏是否显示地形图
      isScaleBoolen: false, // 右边栏是否显示屏陡K指示
      isImageBoolen: true
    },
    cam: "photo"
  },
  fourmaps: {
    key: "fourmaps",
    label: "txtFourMaps",
    rightsider: {
      visible: true,
      isMapBoolen: false,
      isScaleBoolen: false,
      isImageBoolen: true
    },
    cam: "photo"
  },
  factorforms: {
    key: "factorforms",
    label: "txtFactorForms",
    rightsider: {
      visible: true,
      isMapBoolen: false,
      isScaleBoolen: false,
      isImageBoolen: true
    },
    cam: "photo"
  },
  zernike: {
    key: "zernike",
    label: "txtZernike",
    cam: "photo"
  },
  keratoconus: {
    key: "keratoconus",
    label: "txtKeratoconus",
    cam: "photo",
    rightsider: {
      visible: true,
      isMapBoolen: false,
      isScaleBoolen: false,
      isImageBoolen: true
    }
  },
  fourieranalysis: {
    key: "fourieranalysis",
    label: "txtFourierAnalysis",
    cam: "photo"
  },
  pupilcorneadia: {
    key: "pupilcorneadia",
    label: "txtPupilCorneaDiameter",
    cam: "photo"
  },
  contectlens: {
    key: "contectlens",
    label: "txtContectLens",
    cam: "photo"
  },

  compare2records: {
    key: "compare2records",
    label: "txtCompare2Records",
    cam: "photo"
  },
  report: {
    key: "report",
    label: "txtReport",
    cam: "photo"
  }
  // ,
  // calibration: {
  //   key: 'calibration',
  //   label: 'txtCalibration',
  //   cam: 'photo'
  // }
};
export const TOPOGRAPHYCAMPTUREMODES = [
  {
    key: "topography",
    label: "txtTopography",
    diagnosed: "N",
    visibleInCapture: true,
    after: "after"
  },
  {
    key: "pupilcorneadia",
    label: "txtPupilCorneaDiameter",
    diagnosed: "N",
    visibleInCapture: true,
    after: "after"
  }
];
export const RINGNUMBER = 62;
export const DRYEYEMENUS = [
  {
    key: "questionnaire",
    label: "txtQNaire",
    diagnosed: "N",
    visibleInCapture: true,
    after: "after"
  },
  {
    key: "tearheight",
    label: "txtTearHeight",
    diagnosed: "N",
    visibleInCapture: true,
    after: "after"
  },
  {
    key: "nibut",
    label: "txtNibut",
    diagnosed: "N",
    visibleInCapture: true,
    after: "after"
  },
  {
    key: "lipidlayer",
    label: "txtLipidLayer",
    diagnosed: "N",
    visibleInCapture: true,
    after: "after"
  },
  {
    key: "meibomian",
    label: "txtMeibomian",
    diagnosed: "N",
    visibleInCapture: true,
    after: "after"
  },
  {
    key: "eyelidedge",
    label: "txtEyelidEdge",
    diagnosed: "N",
    visibleInCapture: true,
    after: "after"
  },
  {
    key: "eyeredness",
    label: "txtEyeRedness",
    diagnosed: "N",
    visibleInCapture: true,
    after: "after"
  },
  {
    key: "blink",
    label: "txtBlink",
    diagnosed: "N",
    visibleInCapture: true,
    after: "after"
  },
  {
    key: "fbut",
    label: "txtBut",
    diagnosed: "N",
    visibleInCapture: true,
    after: "after"
  },
  {
    key: "ocularsurface",
    label: "txtOcularSurface",
    diagnosed: "N",
    visibleInCapture: true,
    after: "after"
  },
  {
    key: "report",
    label: "txtReport",
    visibleInCapture: false,
    after: ""
  }
];

export const TOPOGRAPHYMENUS = [
  {
    key: "largemap",
    label: "txtLargeMap"
  },
  {
    key: "fourmaps",
    label: "txtFourMaps"
  },
  {
    key: "factorforms",
    label: "txtFactorForms"
  },
  {
    key: "zernike",
    label: "txtZernike"
  },
  {
    key: "keratoconus",
    label: "txtKeratoconus"
  },
  {
    key: "fourieranalysis",
    label: "txtFourierAnalysis"
  },
  {
    key: "pupilcorneadia",
    label: "txtPupilCorneaDiameter",
    after: "after",
    diagnosed: "N"
  },
  {
    key: "contectlens",
    label: "txtContectLens"
  },
  {
    key: "compare2records",
    label: "txtCompare2Records"
  },
  {
    key: "report",
    label: "txtReport"
  }
];
export const LANGUAGES = [
  { key: "zh_CN", label: "简体中文", visible: true },
  { key: "en_US", label: "English", visible: true },
  { key: "fr", label: "français", visible: false },
  { key: "ge", label: "Deutsch", visible: false },
  { key: "po", label: "Português", visible: false },
  { key: "ru", label: "Русский", visible: false },
  { key: "sp", label: "español", visible: false },
  { key: "ja", label: "日本語", visible: true },
  { key: "de", label: "Deutsch", visible: true },
  { key: "it", label: "Italiano", visible: true }
];
export const _LANGUAGES = {
  zh_CN: { label: "简体中文", visible: true },
  en_US: { label: "English", visible: true },
  fr: { label: "français", visible: false },
  ge: { label: "Deutsch", visible: false },
  po: { label: "Português", visible: false },
  ru: { label: "Русский", visible: false },
  sp: { label: "español", visible: false },
  ja: { label: "日本語", visible: true },
  de: { label: "Deutsch", visible: true },
  it: { label: "Italiano", visible: true }
};

export const DATEFORMATS = [
  { key: "yyyymmdd_cn", label: "yyyy年MM月dd日", visible: false },
  { key: "yyyymmdd_line", label: "yyyy-MM-dd", visible: true },
  { key: "mmddyyyy_line", label: "MM-dd-yyyy", visible: true },
  { key: "ddmmyyyy_line", label: "dd-MM-yyyy", visible: true },
  { key: "yyyymmdd_oblique", label: "yyyy/MM/dd", visible: true },
  { key: "mmddyyyy_oblique", label: "MM/dd/yyyy", visible: true },
  { key: "ddmmyyyy_oblique", label: "dd/MM/yyyy", visible: true },
  { key: "yyyymmdd_dot", label: "yyyy.MM.dd", visible: true },
  { key: "mmddyyyy_dot", label: "MM.dd.yyyy", visible: true },
  { key: "ddmmyyyy_dot", label: "dd.MM.yyyy", visible: true }
];

export const _DATEFORMATS = {
  yyyymmdd_cn: { label: "yyyy年MM月dd日", visible: false },
  yyyymmdd_line: { label: "yyyy-MM-dd", visible: true },
  mmddyyyy_line: { label: "MM-dd-yyyy", visible: true },
  ddmmyyyy_line: { label: "dd-MM-yyyy", visible: true },
  yyyymmdd_oblique: { label: "yyyy/MM/dd", visible: true },
  mmddyyyy_oblique: { label: "MM/dd/yyyy", visible: true },
  ddmmyyyy_oblique: { label: "dd/MM/yyyy", visible: true },
  yyyymmdd_dot: { label: "yyyy.MM.dd", visible: true },
  mmddyyyy_dot: { label: "MM.dd.yyyy", visible: true },
  ddmmyyyy_dot: { label: "dd.MM.yyyy", visible: true }
};
export const LOGINSTATES = {
  undo: "undo",
  doing: "doing",
  unLogined: "unLogined",
  logined: "logined",
  failed: "failed"
};
export const PRINTPAPERS = [
  {
    key: "A4",
    visible: true
  },
  {
    key: "A5",
    visible: false
  },
  {
    key: "A6",
    visible: false
  },
  {
    key: "B5",
    visible: false
  },
  {
    key: "USLetter",
    label: "US Letter",
    visible: false
  }
];
export const DICOMSETTINGS = {
  serverip: { value: "127.0.0.1", label: "txtIP" },
  serverport: { value: "3000", label: "txtPortNum" },
  aetitle: { value: "OFFIS", label: "txtDICOMAETitle" },
  localae: { value: "", label: "txtDICOMLocalAE" },
  modality: { value: "YD", label: "txtDICOMModality" }
};
var majMedianModes;
(function (majMedianModes) {
  majMedianModes[(majMedianModes["ecc"] = 0)] = "ecc";
  majMedianModes[(majMedianModes["E"] = 1)] = "E";
  majMedianModes[(majMedianModes["P"] = 2)] = "P";
  majMedianModes[(majMedianModes["Q"] = 3)] = "Q";
  majMedianModes[(majMedianModes["SAGCURV"] = 4)] = "SAGCURV";
})(majMedianModes || (majMedianModes = {}));
export const MAJMEDIANMODES = majMedianModes;
export const RGPMFRDEFAULTNAME = "Mediworks";
export const RGPMFRDEFAULTPHONE = "+86-21-54260421";
export const RGPMFRDEFAULTADDRESS = "Shanghai MediWorks Precision Instruments Co., Ltd.";

export const snlist = {
  newRing: [
    "DEA520-J202409352-01-00001",
    "DEA520-J202409376-01-00001",
    "DEA520-J202409414-01-00001",
    "DEA520-J202409353-01-00001",
    "DEA520-J202409274-01-00005",
    "DEA520-J202409274-01-00004",
    "DEA520-J202409274-01-00003",
    "DEA520-J202409274-01-00002",
    "DEA520-J202409400-01-00001",
    "DEA520-J202409370-01-00001",
    "DEA520-J202409273-01-00001",
    "DEA520-J202409278-01-00002",
    "DEA520-J202409274-01-00001",
    "DEA520-J202409278-01-00001",
    "DEA520-J202409228-01-00001",
    "DEA520-J202409234-01-00001",
    "DEA520-J202409222-01-00001",
    "DEA520-J202409221-01-00001",
    "DEA520-J202408142-01-00005",
    "DEA520-J202408142-01-00004",
    "DEA520-J202408511-01-00001",
    "DEA520-J202408465-01-00001",
    "DEA520-J202408259-01-00003",
    "DEA520-J202408259-01-00002",
    "DEA520-J202408259-01-00001",
    "DEA520-J202408476-01-00002",
    "DEA520-J202408476-01-00001",
    "DEA520-J202408478-01-00001",
    "DEA520-J202408267-01-00006",
    "DEA520-J202408267-01-00005",
    "DEA520-J202408267-01-00004",
    "DEA520-J202408267-01-00003",
    "DEA520-J202408267-01-00002",
    "DEA520-J202408267-01-00001",
    "DEA520-J202408221-01-00001",
    "DEA520-J202408260-01-00001",
    "DEA520-J202408142-01-00002",
    "DEA520-J202408249-01-00002",
    "DEA520-J202408249-01-00001",
    "DEA520-J202408142-01-00001",
    "DEA520-J202407097-01-00005",
    "DEA520-J202408119-01-00002",
    "DEA520-J202408119-01-00001",
    "DEA520-J202408009-01-00002",
    "DEA520-J202408009-01-00001",
    "DEA520-J202407371-01-00003",
    "DEA520-J202407097-01-00004",
    "DEA520-J202407097-01-00003",
    "DEA520-J202407098-01-00002",
    "DEA520-J202407371-01-00002",
    "DEA520-J202407371-01-00001",
    "DEA520-J202407098-01-00001",
    "DEA520-J202407388-01-00001",
    "DEA520-J202406079-01-00008",
    "DEA520-J202407097-01-00002",
    "DEA520-J202407097-01-00001",
    "DEA520-J202405499-01-00002",
    "DEA520-J202404251-01-00001",
    "DEA520-J202405072-01-00005",
    "DEA520-J202405072-01-00004",
    "DEA520-J202407103-01-00001",
    "DEA520-J202407175-01-00001",
    "DEA520-J202407136-01-00001",
    "DEA520-J202407084-01-00001",
    "DEA520-J202404271-01-00003",
    "DEA520-J202406405-01-00001",
    "DEA520-J202405499-01-00001",
    "DEA520-J202406216-01-00001",
    "DEA520-J202406283-01-00002",
    "DEA520-J202406335-01-00001",
    "DEA520-J202406284-01-00001",
    "DEA520-J202406283-01-00001",
    "DEA520-J202405400-01-00001",
    "DEA520-J202406196-01-00001",
    "DEA520-J202405452-01-00002",
    "DEA520-J202405072-01-00003",
    "DEA520-J202405072-01-00002",
    "DEA520-J202406010-01-00001"
  ],
  oldRing: [
    "DEA520-J202205113-01-00002",
    "DEA520-J202205113-01-00001",
    "DEA520-J202205198-01-00001",
    "DEA520-J202205259-01-00001",
    "DEA520-J202205259-01-00002",
    "DEA520-J202205335-01-00001",
    "DEA520-J202205469-01-00001",
    "DEA520-J202205469-01-00002",
    "DEA520-J202205334-01-00001",
    "DEA520-J202205511-01-00001",
    "DEA520-J202205113-01-00003",
    "DEA520-J202205114-01-00001",
    "DEA520-J202205529-01-00001",
    "DEA520-J202205601-01-00001",
    "DEA520-J202206136-01-00001",
    "DEA520-J202205603-01-00001",
    "DEA520-J202205531-01-00001",
    "DEA520-J202205743-01-00001",
    "DEA520-J202205113-01-00004",
    "DEA520-J202205113-01-00005",
    "DEA520-J202206136-01-00002",
    "DEA520-J202207225-01-00001",
    "DEA520-J202207210-01-00001",
    "DEA520-J202207275-01-00001",
    "DEA520-J202207237-01-00001",
    "DEA520-J202205198-01-00002",
    "DEA520-J202205198-01-00003",
    "DEA520-J202207384-01-00001",
    "DEA520-J202206135-01-00001",
    "DEA520-J202206135-01-00002",
    "DEA520-J202207384-01-00002",
    "DEA520-J202207570-01-00001",
    "DEA520-J202207569-01-00001",
    "DEA520-J202205198-01-00004",
    "DEA520-J202208109-01-00001",
    "DEA520-J202207564-01-00001",
    "DEA520-J202207438-01-00001",
    "DEA520-J202207564-01-00001",
    "DEA520-J202207384-01-00003",
    "DEA520-J202206136-01-00004",
    "DEA520-J202206136-01-00003",
    "DEA520-J202205198-01-00005",
    "DEA520-J202208108-01-00001",
    "DEA520-J202205531-01-00002",
    "DEA520-J202206136-01-00005",
    "DEA520-J202208244-01-00001",
    "DEA520-J202207384-01-00004",
    "DEA520-J202207384-01-00005",
    "DEA520-J202207384-01-00006",
    "DEA520-J202208421-01-00001",
    "DEA520-J202206069-01-00001",
    "DEA520-J202206197-01-00001",
    "DEA520-J202206197-01-00002",
    "DEA520-J202207581-01-00001",
    "DEA520-J202207581-01-00002",
    "DEA520-J202207581-01-00005",
    "DEA520-J202207581-01-00004",
    "DEA520-J202207581-01-00003",
    "DEA520-J202207384-01-00007",
    "DEA520-J202209235-01-00001",
    "DEA520-J202207384-01-00008",
    "DEA520-J202207384-01-00009",
    "DEA520-J202207384-01-00010",
    "DEA520-J202206069-01-00002",
    "DEA520-J202206069-01-00003",
    "DEA520-J202210013-01-00001",
    "DEA520-J202209128-01-00001",
    "DEA520-J202210037-01-00001",
    "DEA520-J202210140-01-00001",
    "DEA520-J202209128-01-00002",
    "DEA520-J202211072-01-00001",
    "DEA520-J202210191-01-00001",
    "DEA520-J202210191-01-00002",
    "DEA520-J202206069-01-00002",
    "DEA520-J202206069-01-00003",
    "DEA520-J202210191-01-00003",
    "DEA520-J202210192-01-00001",
    "DEA520-J202212044-01-00001",
    "DEA520-J202212044-01-00002",
    "DEA520-J202212152-01-00001",
    "DEA520-J202212152-01-00002",
    "DEA520-J202212044-01-00003",
    "DEA520-J202212044-01-00004",
    "DEA520-J202210192-01-00002",
    "DEA520-J202210192-01-00003",
    "DEA520-J202212044-01-00005",
    "DEA520-J202210192-01-00004",
    "DEA520-J202212118-01-00001",
    "DEA520-J202212118-01-00002",
    "DEA520-J202212169-01-00001",
    "DEA520-J202212169-01-00002",
    "DEA520-J202212168-01-00001",
    "DEA520-J202212168-01-00002",
    "DEA520-J202212169-01-00003",
    "DEA520-J202212169-01-00004",
    "DEA520-J202212169-01-00005",
    "DEA520-J202301002-01-00001",
    "DEA520-J202301110-01-00001",
    "DEA520-J202301111-01-00001",
    "DEA520-J202212239-01-00001",
    "DEA520-J202301158-01-00001",
    "DEA520-J202301263-01-00001",
    "DEA520-J202301264-01-00001",
    "DEA520-J202301288-01-00001",
    "DEA520-J202302050-01-00001",
    "DEA520-J202301265-01-00001",
    "DEA520-J202302248-01-00001",
    "DEA520-J202301265-01-00001",
    "DEA520-J202302520-01-00001",
    "DEA520-J202301265-01-00002",
    "DEA520-J202302520-01-00002",
    "DEA520-J202303041-01-00002",
    "DEA520-J202302209-01-00001",
    "DEA520-J202302537-01-00001",
    "DEA520-J202302503-01-00001",
    "DEA520-J202303049-01-00001",
    "DEA520-J202303049-01-00002",
    "DEA520-J202303029-01-00001",
    "DEA520-J202303029-01-00002",
    "DEA520-J202303041-01-00003",
    "DEA520-J202303059-01-00001",
    "DEA520-J202303110-01-00001",
    "DEA520-J202303041-01-00004",
    "DEA520-J202303041-01-00001",
    "DEA520-J202303088-01-00001",
    "DEA520-J202303135-01-00001",
    "DEA520-J202303311-01-00001",
    "DEA520-J202303301-01-00001",
    "DEA520-J202303420-01-00001",
    "DEA520-J202303420-01-00002",
    "DEA520-J202303280-01-00001",
    "DEA520-J202303280-01-00002",
    "DEA520-J202303041-01-00005",
    "DEA520-J202303548-01-00001",
    "DEA520-J202303424-01-00001",
    "DEA520-J202304053-01-00001",
    "DEA520-J202304096-01-00001",
    "DEA520-J202304179-01-00001",
    "DEA520-J202304103-01-00001",
    "DEA520-J202304178-01-00001",
    "DEA520-J202303041-01-00006",
    "DEA520-J202304098-01-00001",
    "DEA520-J202304098-01-00002",
    "DEA520-J202303515-01-00001",
    "DEA520-J202303515-01-00002",
    "DEA520-J202304463-01-00001",
    "DEA520-J202303515-01-00003",
    "DEA520-J202304526-01-00001",
    "DEA520-J202303514-01-00001",
    "DEA520-J202304274-01-00001",
    "DEA520-J202304515-01-00001",
    "DEA520-J202305039-01-00001",
    "DEA520-J202304515-01-00002",
    "DEA520-J202303514-01-00002",
    "DEA520-J202304515-01-00003",
    "DEA520-J202303514-01-00003",
    "DEA520-J202304515-01-00004",
    "DEA520-J202305069-01-00001",
    "DEA520-J202305070-01-00001",
    "DEA520-J202305079-01-00001",
    "DEA520-J202305079-01-00002",
    "DEA520-J202305213-01-00001",
    "DEA520-J202305313-01-00001",
    "DEA520-J202304515-01-00005",
    "DEA520-J202305479-01-00001",
    "DEA520-J202305350-01-00001",
    "DEA520-J202305479-01-00002",
    "DEA520-J202305350-01-00002",
    "DEA520-J202305350-01-00003",
    "DEA520-J202305479-01-00003",
    "DEA520-J202306111-01-00001",
    "DEA520-J202306148-01-00001",
    "DEA520-J202306148-01-00002",
    "DEA520-J202306184-01-00001",
    "DEA520-J202305479-01-00004",
    "DEA520-J202306301-01-00001",
    "DEA520-J202306308-01-00001",
    "DEA520-J202306309-01-00001",
    "DEA520-J202306309-01-00002",
    "DEA520-J202306347-01-00001",
    "DEA520-J202306309-01-00003",
    "DEA520-J202306401-01-00001",
    "DEA520-J202306308-01-00001",
    "DEA520-J202305479-01-00005",
    "DEA520-J202306404-01-00001",
    "DEA520-J202305479-01-00006",
    "DEA520-J202307016-01-00001",
    "DEA520-J202306418-01-00001",
    "DEA520-J202306299-01-00001",
    "DEA520-J202306331-01-00001",
    "DEA520-J202307131-01-00001",
    "DEA520-J202307206-01-00001",
    "DEA520-J202307117-01-00001",
    "DEA520-J202306331-01-00002",
    "DEA520-J202307383-01-00001",
    "DEA520-J202307425-01-00001",
    "DEA520-J202305479-01-00007",
    "DEA520-J202306331-01-00003",
    "DEA520-J202307437-01-00001",
    "DEA520-J202307430-01-00001",
    "DEA520-J202306354-01-00001",
    "DEA520-J202307475-01-00001",
    "DEA520-J202306354-01-00002",
    "DEA520-J202306406-01-00001",
    "DEA520-J202305479-01-00008",
    "DEA520-J202307014-01-00001",
    "DEA520-J202306404-01-00002",
    "DEA520-J202306404-01-00003",
    "DEA520-J202308239-01-00001",
    "DEA520-J202308239-01-00002",
    "DEA520-J202308319-01-00001",
    "DEA520-J202309015-01-00001",
    "DEA520-J202308239-01-00003",
    "DEA520-J202308239-01-00004",
    "DEA520-J202308239-01-00005",
    "DEA520-J202308239-01-00006",
    "DEA520-J202308239-01-00007",
    "DEA520-J202309472-01-00001",
    "DEA520-J202309473-01-00001",
    "DEA520-J202309473-01-00002",
    "DEA520-J202306404-01-00004",
    "DEA520-J202309473-01-00003",
    "DEA520-J202310037-01-00001",
    "DEA520-J202310037-01-00002",
    "DEA520-J202310161-01-00001",
    "DEA520-J202309474-01-00001",
    "DEA520-J202310195-01-00001",
    "DEA520-J202310045-01-00001",
    "DEA520-J202310196-01-00001",
    "DEA520-J202310045-01-00002",
    "DEA520-J202310045-01-00003",
    "DEA520-J202310352-01-00001",
    "DEA520-J202310045-01-00004",
    "DEA520-J202310045-01-00005",
    "DEA520-J202310045-01-00006",
    "DEA520-J202306404-01-00005",
    "DEA520-J202310045-01-00007",
    "DEA520-J202311171-01-00001",
    "DEA520-J202306404-01-00006",
    "DEA520-J202311287-01-00001",
    "DEA520-J202311287-01-00002",
    "DEA520-J202311287-01-00003",
    "DEA520-J202311146-01-00001",
    "DEA520-J202311146-01-00002",
    "DEA520-J202312117-01-00001",
    "DEA520-J202312043-01-00001",
    "DEA520-J202312043-01-00002",
    "DEA520-J202311287-01-00004",
    "DEA520-J202311287-01-00005",
    "DEA520-J202312170-01-00001",
    "DEA520-J202312170-01-00002",
    "DEA520-J202312043-01-00004",
    "DEA520-J202312043-01-00003",
    "DEA520-J202312043-01-00005",
    "DEA520-J202311145-01-00001",
    "DEA520-J202401003-01-00001",
    "DEA520-J202311145-01-00002",
    "DEA520-J202311145-01-00003",
    "DEA520-J202311145-01-00004",
    "DEA520-J202401170-01-00001",
    "DEA520-J202311145-01-00005",
    "DEA520-J202401331-01-00001",
    "DEA520-J202401329-01-00001",
    "DEA520-J202401329-01-00002",
    "DEA520-J202402088-01-00001",
    "DEA520-J202402260-01-00001",
    "DEA520-J202402260-01-00002",
    "DEA520-J202402131-01-00001",
    "DEA520-J202403164-01-00001",
    "DEA520-J202403165-01-00001",
    "DEA520-J202402260-01-00003",
    "DEA520-J202402199-01-00001",
    "DEA520-J202403222-01-00001",
    "DEA520-J202403224-01-00001",
    "DEA520-J202402131-01-00002",
    "DEA520-J202403374-01-00001",
    "DEA520-J202402131-01-00003",
    "DEA520-J202402131-01-00004",
    "DEA520-J202402131-01-00005",
    "DEA520-J202404018-01-00001",
    "DEA520-J202404018-01-00002",
    "DEA520-J202402260-01-00004",
    "DEA520-J202402260-01-00005",
    "DEA520-J202404268-01-00001",
    "DEA520-J202404232-01-00001",
    "DEA520-J202404018-01-00003",
    "DEA520-J202404018-01-00004",
    "DEA520-J202404018-01-00005",
    "DEA520-J202404270-01-00001",
    "DEA520-J202404270-01-00002",
    "DEA520-J202404497-01-00001",
    "DEA520-J202404497-01-00002",
    "DEA520-J202404503-01-00001",
    "DEA520-J202403249-01-00001",
    "DEA520-J202404503-01-00002",
    "DEA520-J202404503-01-00003",
    "DEA520-J202404388-01-00001",
    "DEA520-J202404503-01-00004",
    "DEA520-J202404503-01-00005",
    "DEA520-J202405143-01-00001",
    "DEA520-J202405092-01-00001",
    "DEA520-J202405057-01-00001",
    "DEA520-J202405170-01-00001",
    "DEA520-J202405072-01-00001",
    "DEA520-J202405263-01-00001",
    "DEA520-J202404271-01-00001",
    "DEA520-J202405329-01-00001",
    "DEA520-J202405330-01-00001",
    "DEA520-J202405306-01-00001",
    "DEA520-J202405306-01-00002",
    "DEA520-J202405306-01-00003",
    "DEA520-J202404271-01-00002",
    "DEA520-J202405377-01-00001",
    "DEA520-J202405497-01-00001",
    "DEA520-J202405497-01-00002",
    "DEA520-J202405498-01-00001",
    "DEA520-J202408510-01-00001",
    "DEA520-J202408142-01-00003"
  ],
  oldInfrared: [
    "DEA520-J202302537-01-00001",
    "DEA520-J202401291-01-00001",
    "DEA520-J202205113-01-00002",
    "DEA520-J202205113-01-00001",
    "DEA520-J202205198-01-00001",
    "DEA520-J202205259-01-00001",
    "DEA520-J202205259-01-00002",
    "DEA520-J202205335-01-00001",
    "DEA520-J202205469-01-00001",
    "DEA520-J202205469-01-00002",
    "DEA520-J202205334-01-00001",
    "DEA520-J202205511-01-00001",
    "DEA520-J202205113-01-00003",
    "DEA520-J202205114-01-00001",
    "DEA520-J202205529-01-00001",
    "DEA520-J202205601-01-00001",
    "DEA520-J202206136-01-00001",
    "DEA520-J202205603-01-00001",
    "DEA520-J202205531-01-00001",
    "DEA520-J202205743-01-00001",
    "DEA520-J202205113-01-00004",
    "DEA520-J202205113-01-00005",
    "DEA520-J202206136-01-00002",
    "DEA520-J202207225-01-00001",
    "DEA520-J202207210-01-00001",
    "DEA520-J202207275-01-00001",
    "DEA520-J202207237-01-00001",
    "DEA520-J202205198-01-00002",
    "DEA520-J202205198-01-00003",
    "DEA520-J202207384-01-00001",
    "DEA520-J202206135-01-00001",
    "DEA520-J202206135-01-00002",
    "DEA520-J202207384-01-00002",
    "DEA520-J202207570-01-00001",
    "DEA520-J202207569-01-00001",
    "DEA520-J202205198-01-00004",
    "DEA520-J202208109-01-00001",
    "DEA520-J202207564-01-00001",
    "DEA520-J202207438-01-00001",
    "DEA520-J202207564-01-00001",
    "DEA520-J202207384-01-00003",
    "DEA520-J202206136-01-00004",
    "DEA520-J202206136-01-00003",
    "DEA520-J202205198-01-00005",
    "DEA520-J202208108-01-00001",
    "DEA520-J202205531-01-00002",
    "DEA520-J202206136-01-00005",
    "DEA520-J202208244-01-00001",
    "DEA520-J202207384-01-00004",
    "DEA520-J202207384-01-00005",
    "DEA520-J202207384-01-00006",
    "DEA520-J202208421-01-00001",
    "DEA520-J202206069-01-00001",
    "DEA520-J202206197-01-00001",
    "DEA520-J202206197-01-00002",
    "DEA520-J202207581-01-00001",
    "DEA520-J202207581-01-00002",
    "DEA520-J202207581-01-00005",
    "DEA520-J202207581-01-00004",
    "DEA520-J202207581-01-00003",
    "DEA520-J202207384-01-00007",
    "DEA520-J202209235-01-00001",
    "DEA520-J202207384-01-00008",
    "DEA520-J202207384-01-00009",
    "DEA520-J202207384-01-00010",
    "DEA520-J202206069-01-00002",
    "DEA520-J202206069-01-00003",
    "DEA520-J202210013-01-00001",
    "DEA520-J202209128-01-00001",
    "DEA520-J202210037-01-00001",
    "DEA520-J202210140-01-00001",
    "DEA520-J202209128-01-00002",
    "DEA520-J202211072-01-00001",
    "DEA520-J202210191-01-00001",
    "DEA520-J202210191-01-00002",
    "DEA520-J202206069-01-00002",
    "DEA520-J202206069-01-00003",
    "DEA520-J202210191-01-00003",
    "DEA520-J202210192-01-00001",
    "DEA520-J202212044-01-00001",
    "DEA520-J202212044-01-00002",
    "DEA520-J202212152-01-00001",
    "DEA520-J202212152-01-00002",
    "DEA520-J202212044-01-00003",
    "DEA520-J202212044-01-00004",
    "DEA520-J202210192-01-00002",
    "DEA520-J202210192-01-00003",
    "DEA520-J202212044-01-00005",
    "DEA520-J202210192-01-00004",
    "DEA520-J202212118-01-00001",
    "DEA520-J202212118-01-00002",
    "DEA520-J202212169-01-00001",
    "DEA520-J202212169-01-00002",
    "DEA520-J202212168-01-00001",
    "DEA520-J202212168-01-00002",
    "DEA520-J202212169-01-00003",
    "DEA520-J202212169-01-00004",
    "DEA520-J202212169-01-00005",
    "DEA520-J202301002-01-00001",
    "DEA520-J202301110-01-00001",
    "DEA520-J202301111-01-00001",
    "DEA520-J202212239-01-00001",
    "DEA520-J202301158-01-00001",
    "DEA520-J202301263-01-00001",
    "DEA520-J202301264-01-00001",
    "DEA520-J202301288-01-00001",
    "DEA520-J202302050-01-00001",
    "DEA520-J202301265-01-00001",
    "DEA520-J202302248-01-00001",
    "DEA520-J202301265-01-00001"
  ]
};



// WEBPACK FOOTER //
// ./src/shared/consts.js